export const statusOptions = [
  {'text': 'Activo', 'value': 'A'},
  {'text': 'Inactivo', 'value': 'I'},
];

export const statusDictionary = {
  'A': 'ACTIVO',
  'I': 'INACTIVO',
  'P': 'PENDIENTE',
};
